import script from "./KeyDate.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyDate.vue?vue&type=script&setup=true&lang=js"

import "./KeyDate.vue?vue&type=style&index=0&id=7dc5f965&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc5f965"]])

export default __exports__